import { FC } from 'react'
import { t } from 'i18next'
import { differenceInCalendarYears } from 'date-fns'
import styles from './TherapistPost.module.css'
import { Therapist } from '../../../types/Therapist'
import InteractionBase from '../../../common/components/InteractionBase'

interface TherapistPostProps {
  therapist: Therapist
}

const TherapistPost: FC<TherapistPostProps> = ({ therapist }) => {
  const { calendarLink, dateOfBirth, fullName, profileImage, title } = therapist
  const baseUrl = process.env.REACT_APP_BASE_URL
  const age = differenceInCalendarYears(new Date(), new Date(dateOfBirth))

  return (
    <InteractionBase
      title={t('therapists.title')}
      subtitle={t('therapists.subtitle')}
    >
      <div className={styles.container}>
        <div>
          <h2>
            {fullName}, {age}
          </h2>
          <p>{title}</p>
          <img src={`${baseUrl}/${profileImage.src}`} alt={title} />
        </div>
        <a href={calendarLink} target="_blank" rel="noreferrer">
          {t('therapists.buttonText')}
        </a>
      </div>
    </InteractionBase>
  )
}

export default TherapistPost
